<template>
  <div v-if="(!loaded)" class="loading-spinner"></div>
  <div v-if="(loaded)">
    <div class="sobreNos-view">
      <div class="page-title" style="background-color: #000;">
        <div class="auto-container">
          <div class="titulo white" v-html="fc_removeHTML(item.titulo)"></div>
        </div>
      </div>
      <!-- CONTEUDO -->
      <div class="sobreNos-content" style="padding-bottom: 0px;" >
        <div class="auto-container">
          <div class="flex flex-wrap" style="margin-right: -15px;margin-left: -15px;">
            <div class="colunaTitulo col-responsive w-full lg:w-6">
              <div class="title-group inner-column">
                <span class="sectionTitle" v-html="item.titulo"></span>
                <div class="subtitulo" v-html="item.subtitulo"></div>
              </div>
            </div>
            <div class="colunaConteudo col-responsive w-full lg:w-6">
              <div class="inner-column lg:pl-4">
                <div class="paragraph-text" v-html="item.conteudo"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- GALERIA DE IMAGENS -->
      <div class="sobreNos-galeria" style="padding-top: 65px;" v-if="(item.imagens.length > 0)">
        <div class="auto-container">
          <div class="flex flex-wrap">
            <div v-for="(forItem, forIndex) in item.imagens" :key="forIndex" :item="forItem" :class="'image-box w-full lg:w-6 px-3 wow ' + (forIndex % 2 == 0 ? 'fade-in-left' : 'fade-in-right')">
              <div class="imagem" :style="'background-image: url('+ forItem.imagem +');'"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- CARACTERISTICAS  -->
      <div class="sobreNos-caracteristicas" v-if="(item.caracteristicas.length > 0)">
        <div class="auto-container">
          <div class="title-group mb-6">
            <span class="sectionTitle" v-html="'iBase'"></span>
            <div class="subtitulo" v-html="fc_getText(null, 'sobreNos_caracteristicasTitulo')"></div>
          </div>
          <div class="caracteristicas-list">
            <div class="flex flex-wrap">
              <ListCaracteristicaSobreNos  v-for="(forItem, forIndex) in item.caracteristicas" :key="forIndex" :itemIndex="forIndex" :item="forItem" />
            </div>
          </div>
        </div>
      </div>
      <HomeClientes />
      <BannerContactos tipo="2" />
      <BannerRedesSociais />
    </div>
  </div>
</template>

<script>
import ListCaracteristicaSobreNos from '@/components/ListCaracteristicaSobreNos.vue';
import HomeClientes from '@/components/HomeClientes.vue';
import BannerRedesSociais from '@/components/BannerRedesSociais.vue';
import BannerContactos from '@/components/BannerContactos.vue';
export default {
  components: {
    ListCaracteristicaSobreNos,
    HomeClientes,
    BannerRedesSociais,
    BannerContactos
  },
  data() {
    return {
      loaded: false,
      item: {},
    };
  },
  props: {},
  computed: {},
  watch: {},
  methods: {
    mt_start() {
      setTimeout(() => {
        this.loaded = true;
      }, 400)
    },
  },
  created() {},
  mounted() {
    let promises = [];
    promises.push(new Promise((resolve, reject) => { this.fc_fetch({ endpoint: 'SobreNosPagina/', method: 'GET', success: (response) => { this.item = response.item; resolve(); }, error: reject }); }));
    Promise.all(promises).then(() => { this.mt_start(); }).catch((e) => { this.fc_printErrors(e); });
  },
  unmounted() {},
};
</script>

<style scoped>
.sobreNos-content {
  padding:100px 0px;
}
.sobreNos-content .colunaTitulo-subtitulo {
  padding-right: 20px;
  position: relative;
  color: #3c4858;
  font-size: 35px;
  line-height: 50px;
  font-weight: 500;
}
.sobreNos-content .colunaConteudo .inner-column {
  padding-top: 30px;
  margin-left: -15px;
}
.sobreNos-galeria {
  position: relative;
  padding: 150px 0 0px;
}
.sobreNos-galeria:before {
  position: absolute;
  display: inline-block;
  right: 0;
  bottom: 25%;
  height: 681px;
  width: 946px;
  content: "";
  background-image: url("@/assets/icons/map-2.png");
  background-repeat: no-repeat;
}
.sobreNos-galeria .image-box {
  position: relative;
  margin-bottom: 50px;
}
.sobreNos-galeria .image-box .imagem {
  display: block;
  width: 100%;
  height: 350px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  margin: 0;
}
.sobreNos-caracteristicas {
  margin-top: 50px;
  position: relative;
  padding: 0 0 25px;
}
.sobreNos-caracteristicas:before {
  position: absolute;
  right: 0;
  top: -280px;
  height: 1348px;
  width: 1032px;
  content: "";
  background-image: url("@/assets/icons/bg-1.png");
}
.sobreNos-caracteristicas .caracteristicas-list:before {
    position: absolute;
    left: -60px;
    top: -40px;
    height: 490px;
    width: 290px;
    content: "";
    background-image: url("@/assets/icons/dots.png");
}
.sobreNos-caracteristicas .caracteristicas-list {
  position: relative;
}
@media only screen and (max-width: 992px) {
  .sobreNos-galeria .image-box .imagem {
    height: 500px;
  }
}
@media only screen and (max-width: 1023px) {
  .sobreNos-content .colunaConteudo .inner-column{
    margin-left: 0;
  }
}
</style>
